import { Card, CardContent } from '@/components/ui/card'

const EMAIL_REGEX = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g
const EMAIL_TEST_REGEX = /^[\w.+-]+@[\w-]+(?:\.[\w-]+)+$/
const FAQ_REGEX = /(FAQs)/g
const BOLD_TEXT_REGEX =
  /(either 14-18 December 2026 or 16-26 February 2027|There is nothing you need to do at this stage\.)/g
const BOLD_TEXT = new Set([
  'either 14-18 December 2026 or 16-26 February 2027',
  'There is nothing you need to do at this stage.',
])

const renderTextWithBoldPhrases = (text, keyPrefix) =>
  text
    .split(BOLD_TEXT_REGEX)
    .map((chunk, chunkIndex) =>
      BOLD_TEXT.has(chunk) ? (
        <strong key={`${keyPrefix}-bold-${chunkIndex}`}>{chunk}</strong>
      ) : (
        chunk
      )
    )

const renderParagraph = paragraph =>
  paragraph.split(EMAIL_REGEX).flatMap((part, partIndex) =>
    EMAIL_TEST_REGEX.test(part) ? (
      <a
        key={`email-${partIndex}`}
        href={`mailto:${part}`}
        className="font-semibold text-[#ff914d] underline hover:text-[#e67d3a]"
      >
        {part}
      </a>
    ) : (
      part.split(FAQ_REGEX).flatMap((chunk, chunkIndex) =>
        chunk === 'FAQs' ? (
          <a
            key={`faq-${partIndex}-${chunkIndex}`}
            href="https://www.claims1.co.uk/faqs/"
            className="font-semibold text-[#ff914d] underline hover:text-[#e67d3a]"
          >
            {chunk}
          </a>
        ) : (
          renderTextWithBoldPhrases(chunk, `${partIndex}-${chunkIndex}`)
        )
      )
    )
  )

const UpdateSectionCard = ({
  icon: Icon,
  heading,
  content = [],
  as = 'h2',
}) => {
  const Heading = as

  return (
    <Card className="border-foreground/15 rounded-2xl border bg-white">
      <CardContent className="flex gap-4 px-4 py-5 sm:px-6">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#fff3ec]">
          <Icon className="size-5 text-[#ff914d]" aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <Heading className="text-foreground mb-2 text-lg font-bold sm:text-xl">
            {heading}
          </Heading>
          <div className="text-foreground/90 space-y-3 text-sm leading-relaxed sm:text-base">
            {content.map((paragraph, index) => (
              <p key={index}>{renderParagraph(paragraph)}</p>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default UpdateSectionCard
